import BaseService from '../BaseService';
/** Response shape for GET `dashboard/today` on the Funding service (Resi KPI). */
export interface FundingResiKpiResponse {
  reportingDate: string;
  processedCount: number;
  inProgressCount: number;
  helpRequestedCount: number;
}

/** Response shape for funding dashboard count KPI endpoints (amend / draft / submitted breakdown). */
export interface FundingStatusCountsResponse {
  reportingDate: string;
  totalCount: number;
  amendCount: number;
  draftCount: number;
  submittedCount: number;
}
class FundingKpiService extends BaseService {
  constructor() {
    super('/api/funding-service');
  }
  getResiDashboardToday = (): Promise<FundingResiKpiResponse> =>
    this.get<FundingResiKpiResponse>({ path: 'dashboard/today' });

  getCncDashboardToday = (): Promise<FundingStatusCountsResponse> =>
    this.get<FundingStatusCountsResponse>({ path: 'dashboard/cnc/funding-requests/counts' });

  getCreDashboardToday = (): Promise<FundingStatusCountsResponse> =>
    this.get<FundingStatusCountsResponse>({ path: 'dashboard/cre/funding-requests/counts' });

  getCncFinancialStatementsCount = (): Promise<FundingStatusCountsResponse> =>
    this.get<FundingStatusCountsResponse>({ path: 'dashboard/cnc/financial-statements/counts' });

  getCncCollectionStatementsCount = (): Promise<FundingStatusCountsResponse> =>
    this.get<FundingStatusCountsResponse>({ path: 'dashboard/cnc/collections-recycling-notice/counts' });

  getCncServicerReportsCount = (): Promise<FundingStatusCountsResponse> =>
    this.get<FundingStatusCountsResponse>({ path: 'dashboard/cnc/servicer-reports/counts' });

  getCncPaydownNoticesCount = (): Promise<FundingStatusCountsResponse> =>
    this.get<FundingStatusCountsResponse>({ path: 'dashboard/cnc/pay-down-notices/counts' });
}
export default FundingKpiService;
